import customAxios from 'services/customAxios'
import { ROLES } from 'utils/config'

const urls = {
  adminAllUsers: 'admin/users/autocomplete',
}

const getUsers = ({ projectId, taskDetails } = {}) =>
  customAxios({
    method: 'get',
    url: urls.adminAllUsers,
    params: {
      role: ROLES.user.value,
      ...(projectId && { projectId }),
      ...(taskDetails && { taskDetails: true }),
    },
  })

export const autocompleteService = {
  getUsers,
}
